import DetailAction from "@src/components/DetailAction";
import DetailLink from "@src/components/DetailLink";
import ChangeDeviceDialog from "@src/components/dialogs/changeDevice/ChangeDeviceDialog";
import ReadOnlyDetailField from "@src/components/fields/ReadOnlyDetail";
import ReadOnlyDetails from "@src/components/ReadOnlyDetails";
import { getCameraStatusValue } from "@src/domain/devices/edit/Form";
import { type GQLPurchaseAdminQuery } from "@src/graphql.generated";
import { type FC, type FunctionComponent, type PropsWithChildren, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { ChangeDeviceButtonIcon, DetailLinkIcon } from "./CameraInformation.sc";

interface ShowDeviceLinkProps {
    id: string;
}
const ShowDeviceLink: FunctionComponent<PropsWithChildren<ShowDeviceLinkProps>> = ({ id }) => (
    <DetailLink to={`/devices/${id}/edit`}>
        <DetailLinkIcon />
        <FormattedMessage id="reviermanager.purchases.detail.camera.link" defaultMessage="Gerät zeigen" />
    </DetailLink>
);

const CameraInformation: FC<PropsWithChildren<GQLPurchaseAdminQuery>> = ({ licenceAdmin }) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const intl = useIntl();

    if (!licenceAdmin.camera) return null;

    const { id, hardwareInfo, country, status } = licenceAdmin.camera;

    function handleDialogOpen() {
        setDialogOpen(true);
    }

    function handleDialogClose() {
        setDialogOpen(false);
    }

    return (
        <>
            <ChangeDeviceDialog open={dialogOpen} handleClose={handleDialogClose} oldCamera={licenceAdmin.camera} licenceId={licenceAdmin.id} />
            <ReadOnlyDetails
                title={intl.formatMessage({ id: "reviermanager.purchases.detail.camera.title", defaultMessage: "Gerät" })}
                link={<ShowDeviceLink id={id} />}
            >
                <ReadOnlyDetailField
                    value={hardwareInfo.imei}
                    label={intl.formatMessage({ id: "reviermanager.purchases.detail.camera.imei", defaultMessage: "IMEI" })}
                />
                <ReadOnlyDetailField
                    value={hardwareInfo.sn}
                    label={intl.formatMessage({ id: "reviermanager.purchases.detail.camera.sn", defaultMessage: "SN" })}
                />
                <ReadOnlyDetailField
                    value={hardwareInfo.msisdn}
                    label={intl.formatMessage({ id: "reviermanager.purchases.detail.camera.msisdn", defaultMessage: "MSISDN" })}
                />
                <ReadOnlyDetailField
                    value={country}
                    label={intl.formatMessage({ id: "reviermanager.purchases.detail.camera.country", defaultMessage: "Land" })}
                />
                <ReadOnlyDetailField
                    value={getCameraStatusValue(status, intl)}
                    label={intl.formatMessage({ id: "reviermanager.purchases.detail.camera.status", defaultMessage: "Aktivierung" })}
                />
                <DetailAction onClick={handleDialogOpen} icon={<ChangeDeviceButtonIcon />}>
                    <FormattedMessage id="reviermanager.purchases.detail.camera.change" defaultMessage="Gerät wechseln" />
                </DetailAction>
            </ReadOnlyDetails>
        </>
    );
};
export default CameraInformation;
